<template>
    <div class="main-container">
        <div class="filter-container">
            <el-autocomplete
                class="filter-item"
                v-model="selectedBrand.name"
                placeholder="请输入品牌名"
                value-key="name"
                :debounce="500"
                clearable
                @clear="selectedBrand = {}"
                :fetch-suggestions="brandQuerySearch"
                @select="onBrandSelected"
                style="width:250px"
            ></el-autocomplete>
            <el-button class="filter-btn" type="primary" @click="getBrandWhitelist(selectedBrand.id)">搜索</el-button>
            <el-button class="filter-btn" type="primary" @click="brandDialogShow =true">添加</el-button>
        </div>

        <el-table :data="brandTableData" stripe border style="width:100%">
            <el-table-column prop="brand_id" label="品牌ID"></el-table-column>
            <el-table-column prop="brand_name" label="品牌名称"></el-table-column>
            <el-table-column prop="add_time" label="添加时间"></el-table-column>
            <el-table-column label="操作" width="300px">
                <template #default="scope">
                    <div class="action-list">
                        <el-tag @click.prevent="onDel(scope.row.brand_id)" size="small">删除</el-tag>
                        <!-- v-if="scope.row.cat_id != 4" -->
                        <el-tag @click.prevent="onProductSetting(scope.row)" size="small">商品配置</el-tag>
                        <el-button
                            type="primary"
                            size="small"
                            :disabled="scope.row.is_group_close"
                            :title="scope.row.is_group_close ? '该品牌配置已对平台渠道组全部开放' : ''"
                            @click="openBatchPlatform(scope.row)"
                        >批量开放平台渠道</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />
        <!-- 品牌配置 -->
        <el-dialog :close-on-click-modal="false" v-model="brandDialogShow" title="特殊限制" @close="onCloseBrandDialog">
            <el-form label-width="80px">
                <el-form-item label="品牌名称">
                    <el-select v-model="brand_ids" multiple filterable placeholder="请选择品牌" style="width:500px">
                        <el-option
                            v-for="item in brandtList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div style="display: flex;color: red;font-size: small;margin-top: 20px;">
                        <div style="width: 45px;">注意：</div>
                        <div style="display: flex;flex-direction: column;">
                            <div>①未商品配置时，意为屏蔽该品牌下的所有商品</div>
                            <div>②需要屏蔽品牌下的商品时，请在列表内选择【商品配置】</div>
                            <div>③特殊开放，请前往渠道单独设置【特殊品牌/商品开放】</div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button class="filter-btn" type="primary" @click="addBrand()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 商品配置 -->
        <el-dialog v-model="productDialogShow" :title="currBrand.brand_name+'-商品配置'">
            <el-form label-width="80px">
                <el-form-item label="商品">
                    <el-select v-model="selectedProduct" multiple filterable placeholder="请选择商品" style="width:500px">
                        <!-- <el-checkbox class="c-checkbox" v-model="checked" :indeterminate="selectedProduct.length !== productList.length" @change="selectAll">全选</el-checkbox> -->
                        <el-option
                            v-for="item in productList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button class="filter-btn" type="primary" @click="update({brand_id: currBrand.brand_id, product_ids: selectedProduct})">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { useRoute } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive, computed } from 'vue'
import { joinParams } from '@/utils'
export default defineComponent({
name: 'Whitelist',
components: { Pagination },
setup() {
    const { proxy } = getCurrentInstance()
    const route = useRoute()

    const data = reactive({
        selectedBrand:  {       // 当前搜索的品牌
            id:     '',
            name:   ''
        },
        currBrand: {            // 当前操作品牌
            brand_id: '',
            brand_name: ''
        },
        brandTableData: [],     // 品牌数据
        total:          0,
        page_size:      10,
        page:           1,

        selectedProduct: [],      // 当前搜索的商品
        productList: [],
        brandtList: [],
        productTableData: [],   // 商品数据
        brand_ids: '',
        productDialogShow: false,
        brandDialogShow: false,
        openBatchPlatform:(row) => {
            const { brand_id, product_ids, } = row
            let params ={brands_info:[]}
            params.group_id = 34
            // params.channel_id = 34
            params.operation_type = 1
            params.type = 1
            params.channel_genre = 1
            params.brands_info.push({
                brands_id: brand_id,
                products_ids: String(product_ids) // 确保是字符串
            });
            proxy.$confirm(`确认开放平台渠道？`, '提示', {
                type: 'warning'
            }).then(() => {
                proxy.$http.post(`/dsapi/trade/batch_channel_shield`, { ...params }).then(res => {
                    if (res.code != 200) {
                        return proxy.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                    proxy.$message({
                        type: 'success',
                        message: res.msg
                    })
                    data.getBrandWhitelist()
                })
            }).catch(() => {
                console.log('取消删除')
            })

        },
        // 获取白名单品牌
        getPermissionsBrandList: async () => {
            const res = await proxy.$http.get('/channel/permissionsBrand')
            if (res.code != 200) {
                return proxy.$message({
                    type: 'error',
                    message: res.msg
                })
            }
            data.brandtList = res.data
        },
        onCloseBrandDialog: () => {
            data.brand_ids = []
            data.brandDialogShow = false
        },
        // 获取品牌
        getBrandWhitelist: async (search_brand_id = '') => {
            const { page, page_size } = data
            const res = await proxy.$http.get(`/channel/permissions_list?${joinParams({ search_brand_id, page, page_size })}`)
            const { code, data:resData, msg } = res

            if (code != 200) {
                return proxy.$message({
                    type: 'error',
                    message:msg
                })
            }

            const { data:list, total } = resData
            data.brandTableData = list
            data.total = total
        },
        // 品牌搜索查询
        brandQuerySearch: (queryString, cb) => {
            if (queryString != undefined && queryString.length >0) {
                // 获取品牌列表
                proxy.$http.get(`/dsapi/trade/brands_list?brands_name=${queryString.trim()}`).then(res => {
                    if (res.code != 200) return proxy.$message({
                        type: 'error',
                        message: res.msg
                    })
                    cb(res.data)
                })
            } else {
                cb([])
                data.selectedBrand = {}
            }
        },
        // 品牌输入框联想菜单点击事件
        onBrandSelected: (item) => {
            data.selectedBrand = item
        },
        // 添加品牌
        addBrand: () => {
            if (!data.brand_ids) {
                return proxy.$message({
                    type: 'error',
                    message: '请选择品牌'
                })
            }
            
            proxy.$confirm(`确定要添加此品牌？`, '提示', {
                type: 'warning'
            }).then(() => {
                proxy.$http.post('/channel/permissions_add', { brand_ids: data.brand_ids.join(',') }).then(res => {
                    const {code, msg} = res
                    if (code != 200) {
                        return proxy.$message({
                            type: 'error',
                            message: msg
                        })
                    }
                    proxy.$message({
                        type: 'success',
                        message: '添加成功'
                    })
                    data.onCloseBrandDialog()
                    data.getBrandWhitelist()
                })
            }).catch(() => {
                console.log('取消删除')
            })
        },
        // 删除
        onDel: (brand_id, product_id = '') => {
            proxy.$confirm(`确定要删除此${product_id ? '商品' : '品牌（删除品牌同时，品牌下所有商品会同时删除）'}？`, '提示', {
                type: 'warning'
            }).then(() => {
                proxy.update({
                    is_del: 1,
                    brand_id,
                    product_id
                })
            }).catch(() => {
                console.log('取消删除')
            })
        },
        // 删除品牌或更新商品数据请求
        update: ({ is_del = 0, brand_id = '', product_ids = [] }) => {
            proxy.$http.post('/channel/permissions_up', {
                brand_id,
                product_ids: product_ids.join(','),
                status: is_del // 删除
            }).then(res => {
                const { code, msg } = res
                if (code != 200) {
                    return proxy.$message({
                        type: 'error',
                        message: msg
                    })
                }
                proxy.$message({
                    type: 'success',
                    message: '操作成功'
                })
                setTimeout(() => {
                    product_ids.length ? data.productDialogShow = false : data.getBrandWhitelist()
                }, 500)
            })
        },
        // 显示商品配置弹框并获取已添加商品数据
        onProductSetting: (rowData) => {
            data.currBrand = rowData
            const { brand_id } = rowData
            Promise.all([
                proxy.$http.get(`/channel/permissions_list?brand_id=${brand_id}`),
                proxy.$http.get(`/cake/product_list?brand_id=${brand_id}`)
            ]).then(res => {
                const [whiteRes, productRes] = res
                const { code, data:resData, msg } =  whiteRes
                const { code:code01, data:resData01, msg:msg01 } =  productRes
                if (code != 200) {
                    return proxy.$message({
                        type: 'error',
                        message: msg
                    })
                }
                if (code01 != 200) {
                    return proxy.$message({
                        type: 'error',
                        message: msg01
                    })
                }

                let selectedProduct = []
                resData.forEach(item => {
                    selectedProduct.push(item.id)
                })
                data.selectedProduct = selectedProduct
                data.productList = resData01
                data.productDialogShow = true
            })
        },
        // 商品全选
        selectAll: (checked) => {
            if (checked) {
                data.selectedProduct = data.productList.map(p => p.id)
            } else {
                data.selectedProduct = []
            }
        },
        // 翻页
        // onPageChange: (val) => {
        //     data.page = val
        //     data.getBrandWhitelist()
        // }
        onPageChange (val) {
            data.page = val
            data.getBrandWhitelist()
        },
        onSizeChange  (val) {
            data.page_size = val
            data.getBrandWhitelist()
        },
    })
    const checked = computed({
        get: () => data.selectedProduct.length === data.productList.length,
        set: () => {}
    })
    data.getBrandWhitelist()
    data.getPermissionsBrandList()
    return { ...toRefs(data), route, checked }
}
})
</script>

<style lang="stylus" scoped>
    .c-checkbox
        padding 10px 20px 5px
</style>